// Legal documents for lvgimob.md + ipoteca.lvgimob.md (operator: S.R.L. „LVG SOLUTIONS").
// RO + RU, plain client-friendly language, adapted to Law no. 195/2024 (MD).

export const OPERATOR = {
  name: 'S.R.L. „LVG SOLUTIONS”',
  idno: '1017609003191',
  legalAddress: 'MD-3601, mun. Ungheni, str. Zamfir Arbore 54',
  office: 'str. Ion Creangă 4, Zona Economică Liberă Ungheni, mun. Ungheni, MD-3603',
  phone: '+373 69 003 757',
  email: 'lvgimob1@gmail.com',
};

// ---- PRIVACY POLICY ---------------------------------------------------------

export const PRIVACY = {
  ro: [
    { h: '1. Operatorul', p: [
      'Operatorul datelor cu caracter personal prelucrate prin site-urile lvgimob.md și ipoteca.lvgimob.md este S.R.L. „LVG SOLUTIONS”, IDNO 1017609003191.',
      'Adresa juridică: MD-3601, mun. Ungheni, str. Zamfir Arbore 54.',
      'Sediul de activitate: str. Ion Creangă 4, Zona Economică Liberă Ungheni, mun. Ungheni, MD-3603.',
      'Telefon: +373 69 003 757. E-mail: lvgimob1@gmail.com.',
    ]},
    { h: '2. Domeniul de aplicare', p: [
      'Prezenta Politică de confidențialitate se aplică:',
      '• vizitatorilor site-ului lvgimob.md;',
      '• vizitatorilor site-ului ipoteca.lvgimob.md;',
      '• persoanelor care trimit formulare prin aceste site-uri;',
      '• proprietarilor care propun imobile spre vânzare sau chirie;',
      '• persoanelor interesate de cumpărarea, vânzarea sau închirierea unui imobil;',
      '• persoanelor interesate de consultanță ipotecară.',
    ]},
    { h: '3. Datele formularului de contact', p: [
      'Formularul de contact de pe lvgimob.md colectează: numele, numărul de telefon, mesajul transmis și orice alte informații pe care ni le comunicați de bunăvoie.',
    ]},
    { h: '4. Datele formularului „Vreau să vând”', p: [
      'Formularul „Vreau să vând” colectează: numele și prenumele, numărul de telefon, intenția privind vânzarea sau oferirea în chirie, tipul proprietății, localitatea și alte caracteristici ale imobilului, prețul estimat, starea proprietății, descrierea, fotografiile încărcate și alte informații comunicate de bunăvoie.',
      'Vă rugăm să încărcați numai fotografii asupra cărora aveți drept de utilizare și să evitați imaginile care dezvăluie inutil persoane, acte, numere de identificare sau alte date personale.',
    ]},
    { h: '5. Datele formularelor ipotecare', p: [
      'Formularele de pe ipoteca.lvgimob.md colectează: numele, numărul de telefon, etapa în care vă aflați privind alegerea proprietății și a băncii și alte informații pe care ni le comunicați ulterior, de bunăvoie, în discuția cu consultantul.',
      'Prin formularele site-urilor noastre nu se colectează salarii, venituri, IDNP, date bancare sau copii de acte.',
    ]},
    { h: '6. Date colectate automat', p: [
      'La vizitarea site-urilor pot fi colectate automat: adresa de internet a dispozitivului, informații despre dispozitiv și browser, data și ora accesării, paginile și proprietățile vizualizate, sursa accesării și informații despre eventualele erori tehnice. Cookie-urile și datele de analiză a traficului sunt colectate numai după acordul dumneavoastră.',
    ]},
    { h: '7. Scopurile prelucrării', p: [
      'Datele sunt prelucrate pentru:',
      '• primirea și examinarea solicitărilor;',
      '• contactarea persoanelor care au transmis o solicitare;',
      '• oferirea informațiilor solicitate;',
      '• programarea vizionărilor;',
      '• identificarea proprietăților potrivite;',
      '• evaluarea inițială a unei proprietăți propuse;',
      '• pregătirea publicării unei proprietăți;',
      '• comunicarea cu proprietarii;',
      '• oferirea consultației ipotecare;',
      '• facilitarea contactului cu o instituție financiară, numai după informarea prealabilă a persoanei;',
      '• administrarea internă a solicitărilor;',
      '• funcționarea corectă și securitatea site-urilor;',
      '• prevenirea spamului, a utilizării abuzive și a atacurilor;',
      '• remedierea erorilor tehnice;',
      '• realizarea de statistici generale;',
      '• analizarea traficului, numai după acordul dumneavoastră;',
      '• măsurarea eficienței reclamelor noastre, numai după acordul dumneavoastră;',
      '• îndeplinirea obligațiilor legale;',
      '• apărarea drepturilor operatorului.',
    ]},
    { h: '8. Temeiurile juridice', p: [
      'Prelucrarea datelor are la bază:',
      '• solicitarea dumneavoastră și demersurile făcute la cererea dumneavoastră;',
      '• acordul pentru cookie-urile de analiză și publicitate și pentru serviciile externe;',
      '• interesul legitim privind funcționarea, securitatea și administrarea solicitărilor;',
      '• executarea sau pregătirea unei colaborări pe care ați solicitat-o;',
      '• obligațiile legale;',
      '• acordul dumneavoastră sau alt temei legal corespunzător pentru transmiterea datelor către o bancă.',
    ]},
    { h: '9. Contactarea utilizatorului', p: [
      'S.R.L. „LVG SOLUTIONS” vă poate contacta prin telefon, e-mail sau aplicații de mesagerie pentru soluționarea solicitării, prezentarea proprietăților, programarea vizionării, discutarea proprietății propuse sau oferirea consultației ipotecare solicitate.',
      'Trimiterea unui formular nu înseamnă automat acord pentru newslettere sau promoții generale fără legătură cu solicitarea transmisă.',
    ]},
    { h: '10. Transmiterea prin canalul intern de mesagerie', p: [
      'Informațiile din unele formulare și fotografiile proprietăților pot fi transmise printr-un canal intern de mesagerie (Telegram), utilizat doar de persoanele noastre autorizate pentru notificarea și gestionarea rapidă a solicitărilor.',
      'Accesul la acest canal este limitat la persoanele autorizate, mesajele nu sunt trimise către grupuri publice, iar datele transmise se limitează la strictul necesar pentru gestionarea solicitării.',
      'Acest canal poate implica transferuri internaționale de date; ne asigurăm că datele transmise sunt minime și protejate corespunzător.',
    ]},
    { h: '11. Transmiterea către instituțiile financiare', p: [
      'Datele persoanei nu sunt transmise automat unei bănci prin simpla completare a formularului. Dacă, în urma consultației, este necesară transmiterea datelor către o instituție financiară, persoana va fi informată despre destinatar și scop înainte de transmitere, iar datele vor fi comunicate numai în baza unui temei legal corespunzător.',
    ]},
    { h: '12. Destinatarii datelor', p: [
      'Datele pot fi comunicate:',
      '• angajaților și colaboratorilor autorizați;',
      '• furnizorilor de hosting și de mentenanță;',
      '• furnizorilor de servicii de e-mail și comunicații;',
      '• canalului intern de mesagerie descris mai sus, pentru notificări;',
      '• Google, numai după acceptarea serviciilor neesențiale;',
      '• Meta (Facebook), pentru măsurarea eficienței reclamelor, numai după acceptarea cookie-urilor de analiză și publicitate;',
      '• instituțiilor financiare, numai în condițiile descrise la secțiunea 11;',
      '• prestatorilor implicați în serviciile solicitate;',
      '• autorităților publice, dacă legea impune transmiterea.',
      'Datele dumneavoastră nu sunt vândute și nu sunt închiriate către terți.',
    ]},
    { h: '13. Măsurarea eficienței reclamelor (Meta)', p: [
      'Ca să știm dacă reclamele noastre de pe Facebook și Instagram aduc cereri reale, la trimiterea formularului de pe ipoteca.lvgimob.md putem transmite Meta (Facebook) informații despre campania din care ați ajuns pe site, adresa de internet a dispozitivului și informații despre browser.',
      'Numele și numărul de telefon nu sunt trimise în clar: ele sunt transformate într-un cod care nu poate fi citit sau reconstituit. Acest cod este folosit exclusiv pentru statistici privind reclamele, nu pentru a vă contacta și nu pentru a vă urmări pe alte site-uri.',
      'Transmiterea se face numai dacă ați acceptat cookie-urile de analiză și publicitate. Dacă ați ales „Doar necesare”, nu se transmite nimic către Meta.',
    ]},
    { h: '14. Google Analytics', p: [
      'Site-urile utilizează Google Analytics pentru statistici generale privind utilizarea. Acest serviciu poate colecta informații despre dispozitiv, browser, paginile vizitate și durata vizitei.',
      'Google Analytics se activează numai după acceptarea cookie-urilor de analiză.',
    ]},
    { h: '15. Google Maps', p: [
      'Site-urile utilizează hărți Google Maps. La afișarea hărții, către Google pot fi transmise adresa de internet a dispozitivului și informații despre utilizarea hărții.',
      'Hărțile Google sunt încărcate numai după acceptarea serviciilor externe sau după o acțiune clară a dumneavoastră.',
    ]},
    { h: '16. Înregistrările tehnice ale serverului', p: [
      'Serverele noastre rețin informații tehnice de acces (adresa de internet a dispozitivului și informații despre dispozitiv) pentru livrarea paginilor, securitatea site-urilor, prevenirea atacurilor și a utilizării abuzive, remedierea erorilor și statistici generale.',
      'Aceste înregistrări nu sunt folosite pentru profilare sau publicitate.',
    ]},
    { h: '17. Durata păstrării', p: [
      '• solicitările generale: de regulă maximum 24 de luni de la ultima comunicare;',
      '• solicitările privind proprietățile: pe durata colaborării și ulterior cât este necesar pentru gestionarea solicitării și apărarea drepturilor;',
      '• fotografiile neutilizate: șterse după încetarea scopului pentru care au fost transmise;',
      '• solicitările ipotecare: de regulă maximum 24 de luni de la ultima comunicare, dacă nu începe o colaborare;',
      '• înregistrările tehnice ale serverului: de regulă cel mult 90 de zile, dacă nu apare un incident de securitate;',
      '• documentele care rezultă dintr-o colaborare: conform termenelor legale aplicabile;',
      '• cookie-urile: conform duratei declarate în Politica privind cookie-urile.',
    ]},
    { h: '18. Drepturile persoanei vizate', p: [
      'În condițiile Legii nr. 195/2024, aveți dreptul la: informare, acces, rectificare, ștergere, restricționare a prelucrării, opoziție, portabilitate (când este aplicabilă), retragerea acordului, precum și dreptul de a depune o plângere la Centrul Național pentru Protecția Datelor cu Caracter Personal (cnpdpc.gov.md) și de a vă adresa instanței de judecată.',
      'Solicitările privind exercitarea acestor drepturi se transmit la adresa de e-mail lvgimob1@gmail.com.',
    ]},
    { h: '19. Securitatea', p: [
      'Aplicăm măsuri tehnice și organizatorice rezonabile pentru protejarea datelor împotriva accesului neautorizat, pierderii, modificării sau divulgării, inclusiv accesul limitat la persoanele autorizate și un canal intern de notificare controlat.',
    ]},
    { h: '20. Minorii', p: [
      'Site-urile nu se adresează persoanelor sub 16 ani. Nu colectăm cu bună știință date ale minorilor. Dacă aflăm că am primit astfel de date, le ștergem în cel mai scurt timp.',
    ]},
    { h: '21. Linkuri externe', p: [
      'Site-urile pot conține linkuri către site-uri externe (rețele sociale, Google Maps etc.). Nu controlăm și nu răspundem pentru practicile de confidențialitate ale acestor site-uri; vă recomandăm să citiți politicile lor.',
    ]},
    { h: '22. Actualizarea politicii', p: [
      'Această politică poate fi actualizată periodic. Versiunea aplicabilă este cea publicată pe site; modificările semnificative vor fi aduse la cunoștință prin site.',
      'Data ultimei actualizări: 22 septembrie 2026.',
    ]},
  ],
  ru: [
    { h: '1. Оператор', p: [
      'Оператором персональных данных, обрабатываемых на сайтах lvgimob.md и ipoteca.lvgimob.md, является S.R.L. „LVG SOLUTIONS”, IDNO 1017609003191.',
      'Юридический адрес: MD-3601, г. Унгены, ул. Замфир Арборе 54.',
      'Офис: ул. Ион Крянгэ 4, Свободная экономическая зона Унген, г. Унгены, MD-3603.',
      'Телефон: +373 69 003 757. E-mail: lvgimob1@gmail.com.',
    ]},
    { h: '2. Сфера применения', p: [
      'Настоящая Политика конфиденциальности применяется к:',
      '• посетителям сайта lvgimob.md;',
      '• посетителям сайта ipoteca.lvgimob.md;',
      '• лицам, отправляющим формы на этих сайтах;',
      '• собственникам, предлагающим недвижимость на продажу или в аренду;',
      '• лицам, заинтересованным в покупке, продаже или аренде недвижимости;',
      '• лицам, заинтересованным в ипотечной консультации.',
    ]},
    { h: '3. Данные контактной формы', p: [
      'Контактная форма на lvgimob.md собирает: имя, номер телефона, отправленное сообщение и любую другую информацию, которую вы сообщаете добровольно.',
    ]},
    { h: '4. Данные формы «Хочу продать»', p: [
      'Форма «Хочу продать» собирает: имя и фамилию, номер телефона, намерение о продаже или сдаче в аренду, тип недвижимости, населённый пункт и другие характеристики объекта, ориентировочную цену, состояние недвижимости, описание, загруженные фотографии и другую информацию, предоставленную добровольно.',
      'Пожалуйста, загружайте только фотографии, на использование которых у вас есть право, и избегайте изображений, без необходимости раскрывающих лица, документы, идентификационные номера или другие персональные данные.',
    ]},
    { h: '5. Данные ипотечных форм', p: [
      'Формы на ipoteca.lvgimob.md собирают: имя, номер телефона, этап, на котором вы находитесь относительно выбора недвижимости и банка, а также другую информацию, которую вы сообщаете позже, добровольно, в беседе с консультантом.',
      'Через формы наших сайтов не собираются зарплаты, доходы, IDNP, банковские данные или копии документов.',
    ]},
    { h: '6. Данные, собираемые автоматически', p: [
      'При посещении сайтов могут автоматически собираться: интернет-адрес вашего устройства, сведения об устройстве и браузере, дата и время доступа, просмотренные страницы и объекты недвижимости, источник перехода и сведения о возможных технических ошибках. Cookie и данные анализа трафика собираются только с вашего согласия.',
    ]},
    { h: '7. Цели обработки', p: [
      'Данные обрабатываются для:',
      '• получения и рассмотрения запросов;',
      '• связи с лицами, отправившими запрос;',
      '• предоставления запрошенной информации;',
      '• записи на просмотры;',
      '• подбора подходящих объектов недвижимости;',
      '• первоначальной оценки предлагаемого объекта;',
      '• подготовки публикации объекта;',
      '• общения с собственниками;',
      '• предоставления ипотечной консультации;',
      '• содействия контакту с финансовым учреждением только после информирования лица;',
      '• внутреннего управления запросами;',
      '• корректной работы и безопасности сайтов;',
      '• предотвращения спама, недобросовестного использования и атак;',
      '• устранения технических ошибок;',
      '• составления общей статистики;',
      '• анализа трафика только с вашего согласия;',
      '• оценки эффективности нашей рекламы — только с вашего согласия;',
      '• выполнения юридических обязательств;',
      '• защиты прав оператора.',
    ]},
    { h: '8. Правовые основания', p: [
      'Обработка данных основывается на:',
      '• вашем запросе и действиях, выполняемых по вашей просьбе;',
      '• согласии на аналитические и рекламные cookie и на внешние сервисы;',
      '• законном интересе, связанном с работой, безопасностью и управлением запросами;',
      '• исполнении или подготовке сотрудничества, которое вы запросили;',
      '• юридических обязательствах;',
      '• вашем согласии или ином надлежащем правовом основании для передачи данных в банк.',
    ]},
    { h: '9. Связь с пользователем', p: [
      'S.R.L. „LVG SOLUTIONS” может связаться с вами по телефону, электронной почте или в мессенджерах для решения запроса, презентации объектов, записи на просмотр, обсуждения предлагаемого объекта или предоставления запрошенной ипотечной консультации.',
      'Отправка формы не означает автоматическое согласие на рассылки или общую рекламу, не связанную с вашим запросом.',
    ]},
    { h: '10. Передача через внутренний канал сообщений', p: [
      'Информация из некоторых форм и фотографии объектов могут передаваться через внутренний канал сообщений (Telegram), которым пользуются только наши уполномоченные сотрудники для быстрого уведомления и обработки запросов.',
      'Доступ к каналу ограничен уполномоченными лицами, сообщения не отправляются в публичные группы, а передаваемые данные ограничены минимумом, необходимым для обработки запроса.',
      'Этот канал может предполагать международную передачу данных; мы обеспечиваем, чтобы передаваемые данные были минимальными и защищёнными.',
    ]},
    { h: '11. Передача в финансовые учреждения', p: [
      'Данные лица не передаются в банк автоматически только из-за заполнения формы. Если по итогам консультации потребуется передать данные в финансовое учреждение, лицо будет проинформировано о получателе и цели до передачи, а данные будут сообщены только на надлежащем правовом основании.',
    ]},
    { h: '12. Получатели данных', p: [
      'Данные могут передаваться:',
      '• уполномоченным сотрудникам и партнёрам;',
      '• поставщикам хостинга и обслуживания;',
      '• поставщикам услуг электронной почты и связи;',
      '• внутреннему каналу сообщений, описанному выше, для уведомлений;',
      '• Google — только после принятия необязательных сервисов;',
      '• Meta (Facebook) — для оценки эффективности рекламы, только после принятия аналитических и рекламных cookie;',
      '• финансовым учреждениям — только на условиях, описанных в разделе 11;',
      '• исполнителям, задействованным в запрошенных услугах;',
      '• государственным органам, если это требуется по закону.',
      'Ваши данные не продаются и не передаются в аренду третьим лицам.',
    ]},
    { h: '13. Измерение эффективности рекламы (Meta)', p: [
      'Чтобы понимать, приносят ли наши объявления в Facebook и Instagram реальные заявки, при отправке формы на ipoteca.lvgimob.md мы можем передать Meta (Facebook) сведения о рекламной кампании, из которой вы пришли на сайт, интернет-адрес устройства и сведения о браузере.',
      'Имя и номер телефона не передаются в открытом виде: они преобразуются в код, который невозможно прочитать или восстановить. Этот код используется исключительно для статистики по рекламе — не для связи с вами и не для отслеживания на других сайтах.',
      'Передача происходит только в том случае, если вы приняли аналитические и рекламные cookie. Если вы выбрали «Только необходимые», в Meta ничего не передаётся.',
    ]},
    { h: '14. Google Analytics', p: [
      'Сайты используют Google Analytics для общей статистики использования. Этот сервис может собирать сведения об устройстве, браузере, посещённых страницах и длительности визита.',
      'Google Analytics активируется только после принятия аналитических cookie.',
    ]},
    { h: '15. Google Maps', p: [
      'Сайты используют карты Google Maps. При отображении карты в Google могут передаваться интернет-адрес вашего устройства и сведения об использовании карты.',
      'Карты Google загружаются только после принятия внешних сервисов или после явного действия с вашей стороны.',
    ]},
    { h: '16. Технические записи сервера', p: [
      'Наши серверы сохраняют технические сведения о доступе (интернет-адрес устройства и сведения об устройстве) для доставки страниц, безопасности сайтов, предотвращения атак и недобросовестного использования, устранения ошибок и общей статистики.',
      'Эти записи не используются для профилирования или рекламы.',
    ]},
    { h: '17. Сроки хранения', p: [
      '• общие запросы: как правило, не более 24 месяцев с последнего контакта;',
      '• запросы по объектам недвижимости: в течение сотрудничества и далее столько, сколько необходимо для обработки запроса и защиты прав;',
      '• неиспользованные фотографии: удаляются после прекращения цели, для которой были переданы;',
      '• ипотечные запросы: как правило, не более 24 месяцев с последнего контакта, если не началось сотрудничество;',
      '• технические записи сервера: как правило, не более 90 дней, если не возник инцидент безопасности;',
      '• документы, возникшие в результате сотрудничества: согласно применимым законным срокам;',
      '• cookie: согласно сроку, указанному в Политике использования cookie.',
    ]},
    { h: '18. Права субъекта данных', p: [
      'В соответствии с Законом № 195/2024 вы имеете право на: информирование, доступ, исправление, удаление, ограничение обработки, возражение, переносимость (когда применимо), отзыв согласия, а также право подать жалобу в Национальный центр по защите персональных данных (cnpdpc.gov.md) и обратиться в суд.',
      'Запросы по этим правам направляйте на e-mail lvgimob1@gmail.com.',
    ]},
    { h: '19. Безопасность', p: [
      'Мы применяем разумные технические и организационные меры для защиты данных от несанкционированного доступа, утраты, изменения или раскрытия, включая ограниченный доступ уполномоченных лиц и контролируемый внутренний канал уведомлений.',
    ]},
    { h: '20. Несовершеннолетние', p: [
      'Сайты не предназначены для лиц младше 16 лет. Мы сознательно не собираем данные несовершеннолетних. Если нам станет известно о получении таких данных, мы удалим их в кратчайшие сроки.',
    ]},
    { h: '21. Внешние ссылки', p: [
      'Сайты могут содержать ссылки на внешние сайты (социальные сети, Google Maps и др.). Мы не контролируем и не отвечаем за их практики конфиденциальности; рекомендуем ознакомиться с их политиками.',
    ]},
    { h: '22. Обновление политики', p: [
      'Настоящая политика может периодически обновляться. Применяется версия, опубликованная на сайте; о существенных изменениях мы сообщим на сайте.',
      'Дата последнего обновления: 22 сентября 2026 г.',
    ]},
  ],
};

// ---- TERMS & CONDITIONS -----------------------------------------------------

export const TERMS = {
  ro: [
    { h: 'Termeni și condiții', p: [
      'Site-urile lvgimob.md și ipoteca.lvgimob.md sunt operate de S.R.L. „LVG SOLUTIONS”, IDNO 1017609003191, cu sediul de activitate la str. Ion Creangă 4, Zona Economică Liberă Ungheni, mun. Ungheni, MD-3603. Telefon: +373 69 003 757. E-mail: lvgimob1@gmail.com.',
      'Site-urile au caracter informativ: prezintă anunțuri imobiliare și servicii de consultanță, fără a constitui o ofertă contractuală.',
      'Anunțurile, prețurile și informațiile despre proprietăți pot fi actualizate sau modificate în orice moment, fără notificare prealabilă. Înainte de orice decizie, verificați informațiile direct cu echipa noastră.',
      'Trimiterea unui formular prin aceste site-uri nu reprezintă încheierea unui contract.',
      'Formularul de pe ipoteca.lvgimob.md nu reprezintă o cerere oficială de credit.',
      'S.R.L. „LVG SOLUTIONS” nu este bancă și nu acordă credite. Nu garantăm aprobarea niciunui credit de către o instituție financiară.',
      'Societatea vă poate contacta prin telefon, e-mail sau mesagerie în legătură cu solicitarea transmisă.',
      'Utilizarea site-urilor se supune Politicii de confidențialitate și Politicii privind cookie-urile.',
      'Aceste documente pot fi actualizate periodic; versiunea aplicabilă este cea publicată pe site.',
    ]},
  ],
  ru: [
    { h: 'Условия использования', p: [
      'Сайты lvgimob.md и ipoteca.lvgimob.md управляются S.R.L. „LVG SOLUTIONS”, IDNO 1017609003191, офис: ул. Ион Крянгэ 4, Свободная экономическая зона Унген, г. Унгены, MD-3603. Телефон: +373 69 003 757. E-mail: lvgimob1@gmail.com.',
      'Сайты носят информационный характер: они представляют объявления о недвижимости и консультационные услуги и не являются договорной офертой.',
      'Объявления, цены и информация об объектах могут обновляться или изменяться в любое время без предварительного уведомления. Перед любым решением проверяйте информацию напрямую с нашей командой.',
      'Отправка формы через эти сайты не означает заключение договора.',
      'Форма на ipoteca.lvgimob.md не является официальной заявкой на кредит.',
      'S.R.L. „LVG SOLUTIONS” не является банком и не выдаёт кредиты. Мы не гарантируем одобрение кредита финансовым учреждением.',
      'Компания может связаться с вами по телефону, электронной почте или в мессенджерах по поводу отправленного запроса.',
      'Использование сайтов регулируется Политикой конфиденциальности и Политикой использования cookie.',
      'Эти документы могут периодически обновляться; применяется версия, опубликованная на сайте.',
    ]},
  ],
};

// ---- COOKIE POLICY ----------------------------------------------------------

export const COOKIES = {
  ro: [
    { h: 'Ce sunt cookie-urile', p: [
      'Cookie-urile sunt fișiere mici de text stocate pe dispozitivul dumneavoastră atunci când vizitați un site. Ele ajută site-ul să funcționeze corect și permit anumite funcționalități și analize.',
    ]},
    { h: 'Cookie-uri strict necesare', p: [
      'Aceste cookie-uri sunt esențiale pentru funcționarea site-ului (de exemplu, memorarea alegerii privind cookie-urile) și nu pot fi dezactivate. Nu necesită acordul dumneavoastră.',
    ]},
    { h: 'Cookie-uri analitice', p: [
      'Cu acordul dumneavoastră, utilizăm Google Analytics pentru statistici generale privind utilizarea site-ului: pagini vizitate, durata vizitei, dispozitivul și browserul utilizate.',
    ]},
    { h: 'Cookie-uri de publicitate', p: [
      'Cu acordul dumneavoastră, putem folosi cookie-uri care ne ajută să măsurăm eficiența reclamelor de pe Facebook și Instagram: un identificator de browser (păstrat 90 de zile) și un identificator creat din linkul reclamei prin care ați ajuns pe site (păstrat 90 de zile).',
      'Dacă trimiteți un formular pe ipoteca.lvgimob.md, acestora li se pot alătura numele și telefonul dumneavoastră transformate într-un cod care nu poate fi citit sau reconstituit, folosit exclusiv pentru statistici privind reclamele.',
    ]},
    { h: 'Servicii externe', p: [
      'Site-urile utilizează hărți Google Maps. La afișarea hărții, către Google pot fi transmise adresa de internet a dispozitivului și informații despre utilizarea hărții.',
    ]},
    { h: 'Consimțământul', p: [
      'Serviciile neesențiale (Google Analytics, Google Maps și măsurarea reclamelor) sunt activate numai după acceptarea dumneavoastră. Puteți alege opțiunea „Doar necesare”, prin care aceste servicii rămân dezactivate.',
    ]},
    { h: 'Modificarea alegerii', p: [
      'Vă puteți schimba oricând alegerea accesând linkul „Setări cookie” din subsolul paginii. La retragerea acordului, cookie-urile cunoscute sunt șterse acolo unde este posibil.',
    ]},
    { h: 'Durata păstrării', p: [
      'Preferința privind cookie-urile este păstrată timp de 180 de zile. Cookie-urile analitice au duratele proprii stabilite de Google, iar cele de publicitate sunt păstrate 90 de zile.',
    ]},
    { h: 'Operatorul', p: [
      'S.R.L. „LVG SOLUTIONS”, IDNO 1017609003191, str. Ion Creangă 4, Zona Economică Liberă Ungheni, mun. Ungheni, MD-3603. Telefon: +373 69 003 757. E-mail: lvgimob1@gmail.com.',
    ]},
    { h: 'Actualizarea', p: [
      'Data ultimei actualizări: 22 septembrie 2026.',
    ]},
  ],
  ru: [
    { h: 'Что такое cookie', p: [
      'Cookie — это небольшие текстовые файлы, сохраняемые на вашем устройстве при посещении сайта. Они помогают сайту работать корректно и обеспечивают определённые функции и аналитику.',
    ]},
    { h: 'Строго необходимые cookie', p: [
      'Эти cookie необходимы для работы сайта (например, запоминание вашего выбора относительно cookie) и не могут быть отключены. Они не требуют вашего согласия.',
    ]},
    { h: 'Аналитические cookie', p: [
      'С вашего согласия мы используем Google Analytics для общей статистики об использовании сайта: посещённые страницы, длительность визита, используемые устройство и браузер.',
    ]},
    { h: 'Рекламные cookie', p: [
      'С вашего согласия мы можем использовать cookie, помогающие измерять эффективность рекламы в Facebook и Instagram: идентификатор браузера (хранится 90 дней) и идентификатор, созданный из ссылки объявления, по которой вы пришли на сайт (хранится 90 дней).',
      'Если вы отправляете форму на ipoteca.lvgimob.md, к ним могут быть добавлены ваше имя и номер телефона, преобразованные в код, который невозможно прочитать или восстановить; он используется исключительно для статистики по рекламе.',
    ]},
    { h: 'Внешние сервисы', p: [
      'Сайты используют карты Google Maps. При отображении карты в Google могут передаваться интернет-адрес вашего устройства и сведения об использовании карты.',
    ]},
    { h: 'Согласие', p: [
      'Необязательные сервисы (Google Analytics, Google Maps и измерение рекламы) активируются только после вашего согласия. Вы можете выбрать вариант «Только необходимые» — тогда эти сервисы останутся отключёнными.',
    ]},
    { h: 'Изменение выбора', p: [
      'Вы можете изменить свой выбор в любое время по ссылке «Настройки cookie» в подвале страницы. При отзыве согласия известные cookie удаляются, где это возможно.',
    ]},
    { h: 'Срок хранения', p: [
      'Предпочтение относительно cookie хранится 180 дней. Аналитические cookie имеют собственные сроки, установленные Google, а рекламные хранятся 90 дней.',
    ]},
    { h: 'Оператор', p: [
      'S.R.L. „LVG SOLUTIONS”, IDNO 1017609003191, ул. Ион Крянгэ 4, Свободная экономическая зона Унген, г. Унгены, MD-3603. Телефон: +373 69 003 757. E-mail: lvgimob1@gmail.com.',
    ]},
    { h: 'Обновление', p: [
      'Дата последнего обновления: 22 сентября 2026 г.',
    ]},
  ],
};

export const DOC_META = {
  privacy: {
    roTitle: 'Politica de confidențialitate | LVG Imob',
    ruTitle: 'Политика конфиденциальности | LVG Imob',
    roDesc: 'Politica de confidențialitate pentru lvgimob.md și ipoteca.lvgimob.md — operator S.R.L. „LVG SOLUTIONS”. Ce date colectăm, cum le prelucrăm și ce drepturi aveți conform Legii nr. 195/2024.',
    ruDesc: 'Политика конфиденциальности для lvgimob.md и ipoteca.lvgimob.md — оператор S.R.L. «LVG SOLUTIONS». Какие данные мы собираем, как обрабатываем и какие у вас права по Закону № 195/2024.',
    roH1: 'Politica de confidențialitate',
    ruH1: 'Политика конфиденциальности',
    roPath: '/politica-de-confidentialitate',
    ruPath: '/ru/politika-konfidentsialnosti',
  },
  terms: {
    roTitle: 'Termeni și condiții | LVG Imob',
    ruTitle: 'Условия использования | LVG Imob',
    roDesc: 'Termeni și condiții pentru lvgimob.md și ipoteca.lvgimob.md. Site-urile au caracter informativ; formularul ipotecar nu este o cerere oficială de credit.',
    ruDesc: 'Условия использования сайтов lvgimob.md и ipoteca.lvgimob.md. Сайты носят информационный характер; ипотечная форма не является официальной заявкой на кредит.',
    roH1: 'Termeni și condiții',
    ruH1: 'Условия использования',
    roPath: '/termeni-si-conditii',
    ruPath: '/ru/usloviya-ispolzovaniya',
  },
  cookies: {
    roTitle: 'Politica privind cookie-urile | LVG Imob',
    ruTitle: 'Политика использования файлов cookie | LVG Imob',
    roDesc: 'Politica privind cookie-urile pentru lvgimob.md și ipoteca.lvgimob.md: cookie-uri necesare, Google Analytics, Google Maps și măsurarea reclamelor — activate doar cu acordul dvs.',
    ruDesc: 'Политика использования файлов cookie для lvgimob.md и ipoteca.lvgimob.md: необходимые cookie, Google Analytics, Google Maps и измерение рекламы — активируются только с вашего согласия.',
    roH1: 'Politica privind cookie-urile',
    ruH1: 'Политика использования файлов cookie',
    roPath: '/politica-cookie',
    ruPath: '/ru/politika-cookie',
  },
};
